export const recruiterDataset = [
  {
    "role": "UI Designer",
    "industry": "SaaS",
    "exp": 1,
    "required": [
      "User Interviews",
      "Usability Testing",
      "A/B Testing",
      "Wireframing",
      "Prototyping",
      "Interaction Design"
    ],
    "candidate": [
      "Wireframing",
      "Prototyping",
      "Interaction Design",
      "Information Architecture",
      "Visual Design",
      "Typography",
      "Color Theory"
    ],
    "score": 75
  },
  {
    "role": "UI Designer",
    "industry": "SaaS",
    "exp": 2,
    "required": [
      "Usability Testing",
      "A/B Testing",
      "Wireframing",
      "Prototyping",
      "Interaction Design",
      "Information Architecture"
    ],
    "candidate": [
      "Prototyping",
      "Interaction Design",
      "Information Architecture",
      "Visual Design",
      "Typography",
      "Color Theory",
      "Design Systems"
    ],
    "score": 79
  },
  {
    "role": "UI Designer",
    "industry": "SaaS",
    "exp": 3,
    "required": [
      "A/B Testing",
      "Wireframing",
      "Prototyping",
      "Interaction Design",
      "Information Architecture",
      "Visual Design"
    ],
    "candidate": [
      "Interaction Design",
      "Information Architecture",
      "Visual Design",
      "Typography",
      "Color Theory",
      "Design Systems",
      "Design Tokens"
    ],
    "score": 83
  },
  {
    "role": "UI Designer",
    "industry": "SaaS",
    "exp": 5,
    "required": [
      "Wireframing",
      "Prototyping",
      "Interaction Design",
      "Information Architecture",
      "Visual Design",
      "Typography"
    ],
    "candidate": [
      "Information Architecture",
      "Visual Design",
      "Typography",
      "Color Theory",
      "Design Systems",
      "Design Tokens",
      "Auto Layout"
    ],
    "score": 91
  },
  {
    "role": "UI Designer",
    "industry": "SaaS",
    "exp": 7,
    "required": [
      "Prototyping",
      "Interaction Design",
      "Information Architecture",
      "Visual Design",
      "Typography",
      "Color Theory"
    ],
    "candidate": [
      "Visual Design",
      "Typography",
      "Color Theory",
      "Design Systems",
      "Design Tokens",
      "Auto Layout",
      "Components"
    ],
    "score": 99
  },
  {
    "role": "UI Designer",
    "industry": "Enterprise",
    "exp": 1,
    "required": [
      "Interaction Design",
      "Information Architecture",
      "Visual Design",
      "Typography",
      "Color Theory",
      "Design Systems"
    ],
    "candidate": [
      "Typography",
      "Color Theory",
      "Design Systems",
      "Design Tokens",
      "Auto Layout",
      "Components",
      "Variants"
    ],
    "score": 75
  },
  {
    "role": "UI Designer",
    "industry": "Enterprise",
    "exp": 2,
    "required": [
      "Information Architecture",
      "Visual Design",
      "Typography",
      "Color Theory",
      "Design Systems",
      "Design Tokens"
    ],
    "candidate": [
      "Color Theory",
      "Design Systems",
      "Design Tokens",
      "Auto Layout",
      "Components",
      "Variants",
      "Accessibility"
    ],
    "score": 79
  },
  {
    "role": "UI Designer",
    "industry": "Enterprise",
    "exp": 3,
    "required": [
      "Visual Design",
      "Typography",
      "Color Theory",
      "Design Systems",
      "Design Tokens",
      "Auto Layout"
    ],
    "candidate": [
      "Design Systems",
      "Design Tokens",
      "Auto Layout",
      "Components",
      "Variants",
      "Accessibility",
      "WCAG"
    ],
    "score": 83
  },
  {
    "role": "UI Designer",
    "industry": "Enterprise",
    "exp": 5,
    "required": [
      "Typography",
      "Color Theory",
      "Design Systems",
      "Design Tokens",
      "Auto Layout",
      "Components"
    ],
    "candidate": [
      "Design Tokens",
      "Auto Layout",
      "Components",
      "Variants",
      "Accessibility",
      "WCAG",
      "Figma"
    ],
    "score": 91
  },
  {
    "role": "UI Designer",
    "industry": "Enterprise",
    "exp": 7,
    "required": [
      "Color Theory",
      "Design Systems",
      "Design Tokens",
      "Auto Layout",
      "Components",
      "Variants"
    ],
    "candidate": [
      "Auto Layout",
      "Components",
      "Variants",
      "Accessibility",
      "WCAG",
      "Figma",
      "FigJam"
    ],
    "score": 99
  },
  {
    "role": "UI Designer",
    "industry": "FinTech",
    "exp": 1,
    "required": [
      "Design Systems",
      "Design Tokens",
      "Auto Layout",
      "Components",
      "Variants",
      "Accessibility"
    ],
    "candidate": [
      "Components",
      "Variants",
      "Accessibility",
      "WCAG",
      "Figma",
      "FigJam",
      "Framer"
    ],
    "score": 75
  },
  {
    "role": "UI Designer",
    "industry": "FinTech",
    "exp": 2,
    "required": [
      "Design Tokens",
      "Auto Layout",
      "Components",
      "Variants",
      "Accessibility",
      "WCAG"
    ],
    "candidate": [
      "Variants",
      "Accessibility",
      "WCAG",
      "Figma",
      "FigJam",
      "Framer",
      "Sketch"
    ],
    "score": 79
  },
  {
    "role": "UI Designer",
    "industry": "FinTech",
    "exp": 3,
    "required": [
      "Auto Layout",
      "Components",
      "Variants",
      "Accessibility",
      "WCAG",
      "Figma"
    ],
    "candidate": [
      "Accessibility",
      "WCAG",
      "Figma",
      "FigJam",
      "Framer",
      "Sketch",
      "Adobe XD"
    ],
    "score": 83
  },
  {
    "role": "UI Designer",
    "industry": "FinTech",
    "exp": 5,
    "required": [
      "Components",
      "Variants",
      "Accessibility",
      "WCAG",
      "Figma",
      "FigJam"
    ],
    "candidate": [
      "WCAG",
      "Figma",
      "FigJam",
      "Framer",
      "Sketch",
      "Adobe XD",
      "Photoshop"
    ],
    "score": 91
  },
  {
    "role": "UI Designer",
    "industry": "FinTech",
    "exp": 7,
    "required": [
      "Variants",
      "Accessibility",
      "WCAG",
      "Figma",
      "FigJam",
      "Framer"
    ],
    "candidate": [
      "Figma",
      "FigJam",
      "Framer",
      "Sketch",
      "Adobe XD",
      "Photoshop",
      "Illustrator"
    ],
    "score": 99
  },
  {
    "role": "UI Designer",
    "industry": "HealthTech",
    "exp": 1,
    "required": [
      "Accessibility",
      "WCAG",
      "Figma",
      "FigJam",
      "Framer",
      "Sketch"
    ],
    "candidate": [
      "FigJam",
      "Framer",
      "Sketch",
      "Adobe XD",
      "Photoshop",
      "Illustrator",
      "HTML"
    ],
    "score": 75
  },
  {
    "role": "UI Designer",
    "industry": "HealthTech",
    "exp": 2,
    "required": [
      "WCAG",
      "Figma",
      "FigJam",
      "Framer",
      "Sketch",
      "Adobe XD"
    ],
    "candidate": [
      "Framer",
      "Sketch",
      "Adobe XD",
      "Photoshop",
      "Illustrator",
      "HTML",
      "CSS"
    ],
    "score": 79
  },
  {
    "role": "UI Designer",
    "industry": "HealthTech",
    "exp": 3,
    "required": [
      "Figma",
      "FigJam",
      "Framer",
      "Sketch",
      "Adobe XD",
      "Photoshop"
    ],
    "candidate": [
      "Sketch",
      "Adobe XD",
      "Photoshop",
      "Illustrator",
      "HTML",
      "CSS",
      "JavaScript"
    ],
    "score": 83
  },
  {
    "role": "UI Designer",
    "industry": "HealthTech",
    "exp": 5,
    "required": [
      "FigJam",
      "Framer",
      "Sketch",
      "Adobe XD",
      "Photoshop",
      "Illustrator"
    ],
    "candidate": [
      "Adobe XD",
      "Photoshop",
      "Illustrator",
      "HTML",
      "CSS",
      "JavaScript",
      "React"
    ],
    "score": 91
  },
  {
    "role": "UI Designer",
    "industry": "HealthTech",
    "exp": 7,
    "required": [
      "Framer",
      "Sketch",
      "Adobe XD",
      "Photoshop",
      "Illustrator",
      "HTML"
    ],
    "candidate": [
      "Photoshop",
      "Illustrator",
      "HTML",
      "CSS",
      "JavaScript",
      "React",
      "Product Strategy"
    ],
    "score": 99
  },
  {
    "role": "UI Designer",
    "industry": "EdTech",
    "exp": 1,
    "required": [
      "Sketch",
      "Adobe XD",
      "Photoshop",
      "Illustrator",
      "HTML",
      "CSS"
    ],
    "candidate": [
      "Illustrator",
      "HTML",
      "CSS",
      "JavaScript",
      "React",
      "Product Strategy",
      "Stakeholder Management"
    ],
    "score": 75
  },
  {
    "role": "UI Designer",
    "industry": "EdTech",
    "exp": 2,
    "required": [
      "Adobe XD",
      "Photoshop",
      "Illustrator",
      "HTML",
      "CSS",
      "JavaScript"
    ],
    "candidate": [
      "HTML",
      "CSS",
      "JavaScript",
      "React",
      "Product Strategy",
      "Stakeholder Management",
      "Agile"
    ],
    "score": 79
  },
  {
    "role": "UI Designer",
    "industry": "EdTech",
    "exp": 3,
    "required": [
      "Photoshop",
      "Illustrator",
      "HTML",
      "CSS",
      "JavaScript",
      "React"
    ],
    "candidate": [
      "CSS",
      "JavaScript",
      "React",
      "Product Strategy",
      "Stakeholder Management",
      "Agile",
      "Scrum"
    ],
    "score": 83
  },
  {
    "role": "UI Designer",
    "industry": "EdTech",
    "exp": 5,
    "required": [
      "Illustrator",
      "HTML",
      "CSS",
      "JavaScript",
      "React",
      "Product Strategy"
    ],
    "candidate": [
      "JavaScript",
      "React",
      "Product Strategy",
      "Stakeholder Management",
      "Agile",
      "Scrum",
      "GA4"
    ],
    "score": 91
  },
  {
    "role": "UI Designer",
    "industry": "EdTech",
    "exp": 7,
    "required": [
      "HTML",
      "CSS",
      "JavaScript",
      "React",
      "Product Strategy",
      "Stakeholder Management"
    ],
    "candidate": [
      "React",
      "Product Strategy",
      "Stakeholder Management",
      "Agile",
      "Scrum",
      "GA4",
      "Microsoft Clarity"
    ],
    "score": 99
  },
  {
    "role": "UI Designer",
    "industry": "Ecommerce",
    "exp": 1,
    "required": [
      "CSS",
      "JavaScript",
      "React",
      "Product Strategy",
      "Stakeholder Management",
      "Agile"
    ],
    "candidate": [
      "Product Strategy",
      "Stakeholder Management",
      "Agile",
      "Scrum",
      "GA4",
      "Microsoft Clarity",
      "Hotjar"
    ],
    "score": 75
  },
  {
    "role": "UI Designer",
    "industry": "Ecommerce",
    "exp": 2,
    "required": [
      "JavaScript",
      "React",
      "Product Strategy",
      "Stakeholder Management",
      "Agile",
      "Scrum"
    ],
    "candidate": [
      "Stakeholder Management",
      "Agile",
      "Scrum",
      "GA4",
      "Microsoft Clarity",
      "Hotjar",
      "Journey Mapping"
    ],
    "score": 79
  },
  {
    "role": "UI Designer",
    "industry": "Ecommerce",
    "exp": 3,
    "required": [
      "React",
      "Product Strategy",
      "Stakeholder Management",
      "Agile",
      "Scrum",
      "GA4"
    ],
    "candidate": [
      "Agile",
      "Scrum",
      "GA4",
      "Microsoft Clarity",
      "Hotjar",
      "Journey Mapping",
      "Personas"
    ],
    "score": 83
  },
  {
    "role": "UI Designer",
    "industry": "Ecommerce",
    "exp": 5,
    "required": [
      "Product Strategy",
      "Stakeholder Management",
      "Agile",
      "Scrum",
      "GA4",
      "Microsoft Clarity"
    ],
    "candidate": [
      "Scrum",
      "GA4",
      "Microsoft Clarity",
      "Hotjar",
      "Journey Mapping",
      "Personas",
      "Competitive Analysis"
    ],
    "score": 91
  },
  {
    "role": "UI Designer",
    "industry": "Ecommerce",
    "exp": 7,
    "required": [
      "Stakeholder Management",
      "Agile",
      "Scrum",
      "GA4",
      "Microsoft Clarity",
      "Hotjar"
    ],
    "candidate": [
      "GA4",
      "Microsoft Clarity",
      "Hotjar",
      "Journey Mapping",
      "Personas",
      "Competitive Analysis",
      "User Flows"
    ],
    "score": 99
  },
  {
    "role": "UI Designer",
    "industry": "AI",
    "exp": 1,
    "required": [
      "Agile",
      "Scrum",
      "GA4",
      "Microsoft Clarity",
      "Hotjar",
      "Journey Mapping"
    ],
    "candidate": [
      "Microsoft Clarity",
      "Hotjar",
      "Journey Mapping",
      "Personas",
      "Competitive Analysis",
      "User Flows"
    ],
    "score": 75
  },
  {
    "role": "UI Designer",
    "industry": "AI",
    "exp": 2,
    "required": [
      "Scrum",
      "GA4",
      "Microsoft Clarity",
      "Hotjar",
      "Journey Mapping",
      "Personas"
    ],
    "candidate": [
      "Hotjar",
      "Journey Mapping",
      "Personas",
      "Competitive Analysis",
      "User Flows"
    ],
    "score": 79
  },
  {
    "role": "UI Designer",
    "industry": "AI",
    "exp": 3,
    "required": [
      "GA4",
      "Microsoft Clarity",
      "Hotjar",
      "Journey Mapping",
      "Personas",
      "Competitive Analysis"
    ],
    "candidate": [
      "Journey Mapping",
      "Personas",
      "Competitive Analysis",
      "User Flows"
    ],
    "score": 83
  },
  {
    "role": "UI Designer",
    "industry": "AI",
    "exp": 5,
    "required": [
      "Microsoft Clarity",
      "Hotjar",
      "Journey Mapping",
      "Personas",
      "Competitive Analysis",
      "User Flows"
    ],
    "candidate": [
      "Personas",
      "Competitive Analysis",
      "User Flows"
    ],
    "score": 91
  },
  {
    "role": "UI Designer",
    "industry": "AI",
    "exp": 7,
    "required": [
      "Hotjar",
      "Journey Mapping",
      "Personas",
      "Competitive Analysis",
      "User Flows"
    ],
    "candidate": [
      "Competitive Analysis",
      "User Flows"
    ],
    "score": 92
  },
  {
    "role": "UI Designer",
    "industry": "Mining",
    "exp": 1,
    "required": [
      "Journey Mapping",
      "Personas",
      "Competitive Analysis",
      "User Flows"
    ],
    "candidate": [
      "User Flows"
    ],
    "score": 61
  },
  {
    "role": "UI Designer",
    "industry": "Mining",
    "exp": 2,
    "required": [
      "Personas",
      "Competitive Analysis",
      "User Flows"
    ],
    "candidate": [
      "UX Research",
      "User Interviews",
      "Usability Testing",
      "A/B Testing",
      "Wireframing",
      "Prototyping",
      "Interaction Design"
    ],
    "score": 58
  },
  {
    "role": "UI Designer",
    "industry": "Mining",
    "exp": 3,
    "required": [
      "Competitive Analysis",
      "User Flows"
    ],
    "candidate": [
      "User Interviews",
      "Usability Testing",
      "A/B Testing",
      "Wireframing",
      "Prototyping",
      "Interaction Design",
      "Information Architecture"
    ],
    "score": 62
  },
  {
    "role": "UI Designer",
    "industry": "Mining",
    "exp": 5,
    "required": [
      "User Flows"
    ],
    "candidate": [
      "Usability Testing",
      "A/B Testing",
      "Wireframing",
      "Prototyping",
      "Interaction Design",
      "Information Architecture",
      "Visual Design"
    ],
    "score": 70
  },
  {
    "role": "UI Designer",
    "industry": "Mining",
    "exp": 7,
    "required": [
      "UX Research",
      "User Interviews",
      "Usability Testing",
      "A/B Testing",
      "Wireframing",
      "Prototyping"
    ],
    "candidate": [
      "A/B Testing",
      "Wireframing",
      "Prototyping",
      "Interaction Design",
      "Information Architecture",
      "Visual Design",
      "Typography"
    ],
    "score": 99
  },
  {
    "role": "UI Designer",
    "industry": "Travel",
    "exp": 1,
    "required": [
      "User Interviews",
      "Usability Testing",
      "A/B Testing",
      "Wireframing",
      "Prototyping",
      "Interaction Design"
    ],
    "candidate": [
      "Wireframing",
      "Prototyping",
      "Interaction Design",
      "Information Architecture",
      "Visual Design",
      "Typography",
      "Color Theory"
    ],
    "score": 75
  },
  {
    "role": "UI Designer",
    "industry": "Travel",
    "exp": 2,
    "required": [
      "Usability Testing",
      "A/B Testing",
      "Wireframing",
      "Prototyping",
      "Interaction Design",
      "Information Architecture"
    ],
    "candidate": [
      "Prototyping",
      "Interaction Design",
      "Information Architecture",
      "Visual Design",
      "Typography",
      "Color Theory",
      "Design Systems"
    ],
    "score": 79
  },
  {
    "role": "UI Designer",
    "industry": "Travel",
    "exp": 3,
    "required": [
      "A/B Testing",
      "Wireframing",
      "Prototyping",
      "Interaction Design",
      "Information Architecture",
      "Visual Design"
    ],
    "candidate": [
      "Interaction Design",
      "Information Architecture",
      "Visual Design",
      "Typography",
      "Color Theory",
      "Design Systems",
      "Design Tokens"
    ],
    "score": 83
  },
  {
    "role": "UI Designer",
    "industry": "Travel",
    "exp": 5,
    "required": [
      "Wireframing",
      "Prototyping",
      "Interaction Design",
      "Information Architecture",
      "Visual Design",
      "Typography"
    ],
    "candidate": [
      "Information Architecture",
      "Visual Design",
      "Typography",
      "Color Theory",
      "Design Systems",
      "Design Tokens",
      "Auto Layout"
    ],
    "score": 91
  },
  {
    "role": "UI Designer",
    "industry": "Travel",
    "exp": 7,
    "required": [
      "Prototyping",
      "Interaction Design",
      "Information Architecture",
      "Visual Design",
      "Typography",
      "Color Theory"
    ],
    "candidate": [
      "Visual Design",
      "Typography",
      "Color Theory",
      "Design Systems",
      "Design Tokens",
      "Auto Layout",
      "Components"
    ],
    "score": 99
  },
  {
    "role": "UI Designer",
    "industry": "Real Estate",
    "exp": 1,
    "required": [
      "Interaction Design",
      "Information Architecture",
      "Visual Design",
      "Typography",
      "Color Theory",
      "Design Systems"
    ],
    "candidate": [
      "Typography",
      "Color Theory",
      "Design Systems",
      "Design Tokens",
      "Auto Layout",
      "Components",
      "Variants"
    ],
    "score": 75
  },
  {
    "role": "UI Designer",
    "industry": "Real Estate",
    "exp": 2,
    "required": [
      "Information Architecture",
      "Visual Design",
      "Typography",
      "Color Theory",
      "Design Systems",
      "Design Tokens"
    ],
    "candidate": [
      "Color Theory",
      "Design Systems",
      "Design Tokens",
      "Auto Layout",
      "Components",
      "Variants",
      "Accessibility"
    ],
    "score": 79
  },
  {
    "role": "UI Designer",
    "industry": "Real Estate",
    "exp": 3,
    "required": [
      "Visual Design",
      "Typography",
      "Color Theory",
      "Design Systems",
      "Design Tokens",
      "Auto Layout"
    ],
    "candidate": [
      "Design Systems",
      "Design Tokens",
      "Auto Layout",
      "Components",
      "Variants",
      "Accessibility",
      "WCAG"
    ],
    "score": 83
  },
  {
    "role": "UI Designer",
    "industry": "Real Estate",
    "exp": 5,
    "required": [
      "Typography",
      "Color Theory",
      "Design Systems",
      "Design Tokens",
      "Auto Layout",
      "Components"
    ],
    "candidate": [
      "Design Tokens",
      "Auto Layout",
      "Components",
      "Variants",
      "Accessibility",
      "WCAG",
      "Figma"
    ],
    "score": 91
  },
  {
    "role": "UI Designer",
    "industry": "Real Estate",
    "exp": 7,
    "required": [
      "Color Theory",
      "Design Systems",
      "Design Tokens",
      "Auto Layout",
      "Components",
      "Variants"
    ],
    "candidate": [
      "Auto Layout",
      "Components",
      "Variants",
      "Accessibility",
      "WCAG",
      "Figma",
      "FigJam"
    ],
    "score": 99
  },
  {
    "role": "UX Designer",
    "industry": "SaaS",
    "exp": 1,
    "required": [
      "Design Systems",
      "Design Tokens",
      "Auto Layout",
      "Components",
      "Variants",
      "Accessibility"
    ],
    "candidate": [
      "Components",
      "Variants",
      "Accessibility",
      "WCAG",
      "Figma",
      "FigJam",
      "Framer"
    ],
    "score": 75
  },
  {
    "role": "UX Designer",
    "industry": "SaaS",
    "exp": 2,
    "required": [
      "Design Tokens",
      "Auto Layout",
      "Components",
      "Variants",
      "Accessibility",
      "WCAG"
    ],
    "candidate": [
      "Variants",
      "Accessibility",
      "WCAG",
      "Figma",
      "FigJam",
      "Framer",
      "Sketch"
    ],
    "score": 79
  },
  {
    "role": "UX Designer",
    "industry": "SaaS",
    "exp": 3,
    "required": [
      "Auto Layout",
      "Components",
      "Variants",
      "Accessibility",
      "WCAG",
      "Figma"
    ],
    "candidate": [
      "Accessibility",
      "WCAG",
      "Figma",
      "FigJam",
      "Framer",
      "Sketch",
      "Adobe XD"
    ],
    "score": 83
  },
  {
    "role": "UX Designer",
    "industry": "SaaS",
    "exp": 5,
    "required": [
      "Components",
      "Variants",
      "Accessibility",
      "WCAG",
      "Figma",
      "FigJam"
    ],
    "candidate": [
      "WCAG",
      "Figma",
      "FigJam",
      "Framer",
      "Sketch",
      "Adobe XD",
      "Photoshop"
    ],
    "score": 91
  },
  {
    "role": "UX Designer",
    "industry": "SaaS",
    "exp": 7,
    "required": [
      "Variants",
      "Accessibility",
      "WCAG",
      "Figma",
      "FigJam",
      "Framer"
    ],
    "candidate": [
      "Figma",
      "FigJam",
      "Framer",
      "Sketch",
      "Adobe XD",
      "Photoshop",
      "Illustrator"
    ],
    "score": 99
  },
  {
    "role": "UX Designer",
    "industry": "Enterprise",
    "exp": 1,
    "required": [
      "Accessibility",
      "WCAG",
      "Figma",
      "FigJam",
      "Framer",
      "Sketch"
    ],
    "candidate": [
      "FigJam",
      "Framer",
      "Sketch",
      "Adobe XD",
      "Photoshop",
      "Illustrator",
      "HTML"
    ],
    "score": 75
  },
  {
    "role": "UX Designer",
    "industry": "Enterprise",
    "exp": 2,
    "required": [
      "WCAG",
      "Figma",
      "FigJam",
      "Framer",
      "Sketch",
      "Adobe XD"
    ],
    "candidate": [
      "Framer",
      "Sketch",
      "Adobe XD",
      "Photoshop",
      "Illustrator",
      "HTML",
      "CSS"
    ],
    "score": 79
  },
  {
    "role": "UX Designer",
    "industry": "Enterprise",
    "exp": 3,
    "required": [
      "Figma",
      "FigJam",
      "Framer",
      "Sketch",
      "Adobe XD",
      "Photoshop"
    ],
    "candidate": [
      "Sketch",
      "Adobe XD",
      "Photoshop",
      "Illustrator",
      "HTML",
      "CSS",
      "JavaScript"
    ],
    "score": 83
  },
  {
    "role": "UX Designer",
    "industry": "Enterprise",
    "exp": 5,
    "required": [
      "FigJam",
      "Framer",
      "Sketch",
      "Adobe XD",
      "Photoshop",
      "Illustrator"
    ],
    "candidate": [
      "Adobe XD",
      "Photoshop",
      "Illustrator",
      "HTML",
      "CSS",
      "JavaScript",
      "React"
    ],
    "score": 91
  },
  {
    "role": "UX Designer",
    "industry": "Enterprise",
    "exp": 7,
    "required": [
      "Framer",
      "Sketch",
      "Adobe XD",
      "Photoshop",
      "Illustrator",
      "HTML"
    ],
    "candidate": [
      "Photoshop",
      "Illustrator",
      "HTML",
      "CSS",
      "JavaScript",
      "React",
      "Product Strategy"
    ],
    "score": 99
  },
  {
    "role": "UX Designer",
    "industry": "FinTech",
    "exp": 1,
    "required": [
      "Sketch",
      "Adobe XD",
      "Photoshop",
      "Illustrator",
      "HTML",
      "CSS"
    ],
    "candidate": [
      "Illustrator",
      "HTML",
      "CSS",
      "JavaScript",
      "React",
      "Product Strategy",
      "Stakeholder Management"
    ],
    "score": 75
  },
  {
    "role": "UX Designer",
    "industry": "FinTech",
    "exp": 2,
    "required": [
      "Adobe XD",
      "Photoshop",
      "Illustrator",
      "HTML",
      "CSS",
      "JavaScript"
    ],
    "candidate": [
      "HTML",
      "CSS",
      "JavaScript",
      "React",
      "Product Strategy",
      "Stakeholder Management",
      "Agile"
    ],
    "score": 79
  },
  {
    "role": "UX Designer",
    "industry": "FinTech",
    "exp": 3,
    "required": [
      "Photoshop",
      "Illustrator",
      "HTML",
      "CSS",
      "JavaScript",
      "React"
    ],
    "candidate": [
      "CSS",
      "JavaScript",
      "React",
      "Product Strategy",
      "Stakeholder Management",
      "Agile",
      "Scrum"
    ],
    "score": 83
  },
  {
    "role": "UX Designer",
    "industry": "FinTech",
    "exp": 5,
    "required": [
      "Illustrator",
      "HTML",
      "CSS",
      "JavaScript",
      "React",
      "Product Strategy"
    ],
    "candidate": [
      "JavaScript",
      "React",
      "Product Strategy",
      "Stakeholder Management",
      "Agile",
      "Scrum",
      "GA4"
    ],
    "score": 91
  },
  {
    "role": "UX Designer",
    "industry": "FinTech",
    "exp": 7,
    "required": [
      "HTML",
      "CSS",
      "JavaScript",
      "React",
      "Product Strategy",
      "Stakeholder Management"
    ],
    "candidate": [
      "React",
      "Product Strategy",
      "Stakeholder Management",
      "Agile",
      "Scrum",
      "GA4",
      "Microsoft Clarity"
    ],
    "score": 99
  },
  {
    "role": "UX Designer",
    "industry": "HealthTech",
    "exp": 1,
    "required": [
      "CSS",
      "JavaScript",
      "React",
      "Product Strategy",
      "Stakeholder Management",
      "Agile"
    ],
    "candidate": [
      "Product Strategy",
      "Stakeholder Management",
      "Agile",
      "Scrum",
      "GA4",
      "Microsoft Clarity",
      "Hotjar"
    ],
    "score": 75
  },
  {
    "role": "UX Designer",
    "industry": "HealthTech",
    "exp": 2,
    "required": [
      "JavaScript",
      "React",
      "Product Strategy",
      "Stakeholder Management",
      "Agile",
      "Scrum"
    ],
    "candidate": [
      "Stakeholder Management",
      "Agile",
      "Scrum",
      "GA4",
      "Microsoft Clarity",
      "Hotjar",
      "Journey Mapping"
    ],
    "score": 79
  },
  {
    "role": "UX Designer",
    "industry": "HealthTech",
    "exp": 3,
    "required": [
      "React",
      "Product Strategy",
      "Stakeholder Management",
      "Agile",
      "Scrum",
      "GA4"
    ],
    "candidate": [
      "Agile",
      "Scrum",
      "GA4",
      "Microsoft Clarity",
      "Hotjar",
      "Journey Mapping",
      "Personas"
    ],
    "score": 83
  },
  {
    "role": "UX Designer",
    "industry": "HealthTech",
    "exp": 5,
    "required": [
      "Product Strategy",
      "Stakeholder Management",
      "Agile",
      "Scrum",
      "GA4",
      "Microsoft Clarity"
    ],
    "candidate": [
      "Scrum",
      "GA4",
      "Microsoft Clarity",
      "Hotjar",
      "Journey Mapping",
      "Personas",
      "Competitive Analysis"
    ],
    "score": 91
  },
  {
    "role": "UX Designer",
    "industry": "HealthTech",
    "exp": 7,
    "required": [
      "Stakeholder Management",
      "Agile",
      "Scrum",
      "GA4",
      "Microsoft Clarity",
      "Hotjar"
    ],
    "candidate": [
      "GA4",
      "Microsoft Clarity",
      "Hotjar",
      "Journey Mapping",
      "Personas",
      "Competitive Analysis",
      "User Flows"
    ],
    "score": 99
  },
  {
    "role": "UX Designer",
    "industry": "EdTech",
    "exp": 1,
    "required": [
      "Agile",
      "Scrum",
      "GA4",
      "Microsoft Clarity",
      "Hotjar",
      "Journey Mapping"
    ],
    "candidate": [
      "Microsoft Clarity",
      "Hotjar",
      "Journey Mapping",
      "Personas",
      "Competitive Analysis",
      "User Flows"
    ],
    "score": 75
  },
  {
    "role": "UX Designer",
    "industry": "EdTech",
    "exp": 2,
    "required": [
      "Scrum",
      "GA4",
      "Microsoft Clarity",
      "Hotjar",
      "Journey Mapping",
      "Personas"
    ],
    "candidate": [
      "Hotjar",
      "Journey Mapping",
      "Personas",
      "Competitive Analysis",
      "User Flows"
    ],
    "score": 79
  },
  {
    "role": "UX Designer",
    "industry": "EdTech",
    "exp": 3,
    "required": [
      "GA4",
      "Microsoft Clarity",
      "Hotjar",
      "Journey Mapping",
      "Personas",
      "Competitive Analysis"
    ],
    "candidate": [
      "Journey Mapping",
      "Personas",
      "Competitive Analysis",
      "User Flows"
    ],
    "score": 83
  },
  {
    "role": "UX Designer",
    "industry": "EdTech",
    "exp": 5,
    "required": [
      "Microsoft Clarity",
      "Hotjar",
      "Journey Mapping",
      "Personas",
      "Competitive Analysis",
      "User Flows"
    ],
    "candidate": [
      "Personas",
      "Competitive Analysis",
      "User Flows"
    ],
    "score": 91
  },
  {
    "role": "UX Designer",
    "industry": "EdTech",
    "exp": 7,
    "required": [
      "Hotjar",
      "Journey Mapping",
      "Personas",
      "Competitive Analysis",
      "User Flows"
    ],
    "candidate": [
      "Competitive Analysis",
      "User Flows"
    ],
    "score": 92
  },
  {
    "role": "UX Designer",
    "industry": "Ecommerce",
    "exp": 1,
    "required": [
      "Journey Mapping",
      "Personas",
      "Competitive Analysis",
      "User Flows"
    ],
    "candidate": [
      "User Flows"
    ],
    "score": 61
  },
  {
    "role": "UX Designer",
    "industry": "Ecommerce",
    "exp": 2,
    "required": [
      "Personas",
      "Competitive Analysis",
      "User Flows"
    ],
    "candidate": [
      "UX Research",
      "User Interviews",
      "Usability Testing",
      "A/B Testing",
      "Wireframing",
      "Prototyping",
      "Interaction Design"
    ],
    "score": 58
  },
  {
    "role": "UX Designer",
    "industry": "Ecommerce",
    "exp": 3,
    "required": [
      "Competitive Analysis",
      "User Flows"
    ],
    "candidate": [
      "User Interviews",
      "Usability Testing",
      "A/B Testing",
      "Wireframing",
      "Prototyping",
      "Interaction Design",
      "Information Architecture"
    ],
    "score": 62
  },
  {
    "role": "UX Designer",
    "industry": "Ecommerce",
    "exp": 5,
    "required": [
      "User Flows"
    ],
    "candidate": [
      "Usability Testing",
      "A/B Testing",
      "Wireframing",
      "Prototyping",
      "Interaction Design",
      "Information Architecture",
      "Visual Design"
    ],
    "score": 70
  },
  {
    "role": "UX Designer",
    "industry": "Ecommerce",
    "exp": 7,
    "required": [
      "UX Research",
      "User Interviews",
      "Usability Testing",
      "A/B Testing",
      "Wireframing",
      "Prototyping"
    ],
    "candidate": [
      "A/B Testing",
      "Wireframing",
      "Prototyping",
      "Interaction Design",
      "Information Architecture",
      "Visual Design",
      "Typography"
    ],
    "score": 99
  },
  {
    "role": "UX Designer",
    "industry": "AI",
    "exp": 1,
    "required": [
      "User Interviews",
      "Usability Testing",
      "A/B Testing",
      "Wireframing",
      "Prototyping",
      "Interaction Design"
    ],
    "candidate": [
      "Wireframing",
      "Prototyping",
      "Interaction Design",
      "Information Architecture",
      "Visual Design",
      "Typography",
      "Color Theory"
    ],
    "score": 75
  },
  {
    "role": "UX Designer",
    "industry": "AI",
    "exp": 2,
    "required": [
      "Usability Testing",
      "A/B Testing",
      "Wireframing",
      "Prototyping",
      "Interaction Design",
      "Information Architecture"
    ],
    "candidate": [
      "Prototyping",
      "Interaction Design",
      "Information Architecture",
      "Visual Design",
      "Typography",
      "Color Theory",
      "Design Systems"
    ],
    "score": 79
  },
  {
    "role": "UX Designer",
    "industry": "AI",
    "exp": 3,
    "required": [
      "A/B Testing",
      "Wireframing",
      "Prototyping",
      "Interaction Design",
      "Information Architecture",
      "Visual Design"
    ],
    "candidate": [
      "Interaction Design",
      "Information Architecture",
      "Visual Design",
      "Typography",
      "Color Theory",
      "Design Systems",
      "Design Tokens"
    ],
    "score": 83
  },
  {
    "role": "UX Designer",
    "industry": "AI",
    "exp": 5,
    "required": [
      "Wireframing",
      "Prototyping",
      "Interaction Design",
      "Information Architecture",
      "Visual Design",
      "Typography"
    ],
    "candidate": [
      "Information Architecture",
      "Visual Design",
      "Typography",
      "Color Theory",
      "Design Systems",
      "Design Tokens",
      "Auto Layout"
    ],
    "score": 91
  },
  {
    "role": "UX Designer",
    "industry": "AI",
    "exp": 7,
    "required": [
      "Prototyping",
      "Interaction Design",
      "Information Architecture",
      "Visual Design",
      "Typography",
      "Color Theory"
    ],
    "candidate": [
      "Visual Design",
      "Typography",
      "Color Theory",
      "Design Systems",
      "Design Tokens",
      "Auto Layout",
      "Components"
    ],
    "score": 99
  },
  {
    "role": "UX Designer",
    "industry": "Mining",
    "exp": 1,
    "required": [
      "Interaction Design",
      "Information Architecture",
      "Visual Design",
      "Typography",
      "Color Theory",
      "Design Systems"
    ],
    "candidate": [
      "Typography",
      "Color Theory",
      "Design Systems",
      "Design Tokens",
      "Auto Layout",
      "Components",
      "Variants"
    ],
    "score": 75
  },
  {
    "role": "UX Designer",
    "industry": "Mining",
    "exp": 2,
    "required": [
      "Information Architecture",
      "Visual Design",
      "Typography",
      "Color Theory",
      "Design Systems",
      "Design Tokens"
    ],
    "candidate": [
      "Color Theory",
      "Design Systems",
      "Design Tokens",
      "Auto Layout",
      "Components",
      "Variants",
      "Accessibility"
    ],
    "score": 79
  },
  {
    "role": "UX Designer",
    "industry": "Mining",
    "exp": 3,
    "required": [
      "Visual Design",
      "Typography",
      "Color Theory",
      "Design Systems",
      "Design Tokens",
      "Auto Layout"
    ],
    "candidate": [
      "Design Systems",
      "Design Tokens",
      "Auto Layout",
      "Components",
      "Variants",
      "Accessibility",
      "WCAG"
    ],
    "score": 83
  },
  {
    "role": "UX Designer",
    "industry": "Mining",
    "exp": 5,
    "required": [
      "Typography",
      "Color Theory",
      "Design Systems",
      "Design Tokens",
      "Auto Layout",
      "Components"
    ],
    "candidate": [
      "Design Tokens",
      "Auto Layout",
      "Components",
      "Variants",
      "Accessibility",
      "WCAG",
      "Figma"
    ],
    "score": 91
  },
  {
    "role": "UX Designer",
    "industry": "Mining",
    "exp": 7,
    "required": [
      "Color Theory",
      "Design Systems",
      "Design Tokens",
      "Auto Layout",
      "Components",
      "Variants"
    ],
    "candidate": [
      "Auto Layout",
      "Components",
      "Variants",
      "Accessibility",
      "WCAG",
      "Figma",
      "FigJam"
    ],
    "score": 99
  },
  {
    "role": "UX Designer",
    "industry": "Travel",
    "exp": 1,
    "required": [
      "Design Systems",
      "Design Tokens",
      "Auto Layout",
      "Components",
      "Variants",
      "Accessibility"
    ],
    "candidate": [
      "Components",
      "Variants",
      "Accessibility",
      "WCAG",
      "Figma",
      "FigJam",
      "Framer"
    ],
    "score": 75
  },
  {
    "role": "UX Designer",
    "industry": "Travel",
    "exp": 2,
    "required": [
      "Design Tokens",
      "Auto Layout",
      "Components",
      "Variants",
      "Accessibility",
      "WCAG"
    ],
    "candidate": [
      "Variants",
      "Accessibility",
      "WCAG",
      "Figma",
      "FigJam",
      "Framer",
      "Sketch"
    ],
    "score": 79
  },
  {
    "role": "UX Designer",
    "industry": "Travel",
    "exp": 3,
    "required": [
      "Auto Layout",
      "Components",
      "Variants",
      "Accessibility",
      "WCAG",
      "Figma"
    ],
    "candidate": [
      "Accessibility",
      "WCAG",
      "Figma",
      "FigJam",
      "Framer",
      "Sketch",
      "Adobe XD"
    ],
    "score": 83
  },
  {
    "role": "UX Designer",
    "industry": "Travel",
    "exp": 5,
    "required": [
      "Components",
      "Variants",
      "Accessibility",
      "WCAG",
      "Figma",
      "FigJam"
    ],
    "candidate": [
      "WCAG",
      "Figma",
      "FigJam",
      "Framer",
      "Sketch",
      "Adobe XD",
      "Photoshop"
    ],
    "score": 91
  },
  {
    "role": "UX Designer",
    "industry": "Travel",
    "exp": 7,
    "required": [
      "Variants",
      "Accessibility",
      "WCAG",
      "Figma",
      "FigJam",
      "Framer"
    ],
    "candidate": [
      "Figma",
      "FigJam",
      "Framer",
      "Sketch",
      "Adobe XD",
      "Photoshop",
      "Illustrator"
    ],
    "score": 99
  },
  {
    "role": "UX Designer",
    "industry": "Real Estate",
    "exp": 1,
    "required": [
      "Accessibility",
      "WCAG",
      "Figma",
      "FigJam",
      "Framer",
      "Sketch"
    ],
    "candidate": [
      "FigJam",
      "Framer",
      "Sketch",
      "Adobe XD",
      "Photoshop",
      "Illustrator",
      "HTML"
    ],
    "score": 75
  },
  {
    "role": "UX Designer",
    "industry": "Real Estate",
    "exp": 2,
    "required": [
      "WCAG",
      "Figma",
      "FigJam",
      "Framer",
      "Sketch",
      "Adobe XD"
    ],
    "candidate": [
      "Framer",
      "Sketch",
      "Adobe XD",
      "Photoshop",
      "Illustrator",
      "HTML",
      "CSS"
    ],
    "score": 79
  },
  {
    "role": "UX Designer",
    "industry": "Real Estate",
    "exp": 3,
    "required": [
      "Figma",
      "FigJam",
      "Framer",
      "Sketch",
      "Adobe XD",
      "Photoshop"
    ],
    "candidate": [
      "Sketch",
      "Adobe XD",
      "Photoshop",
      "Illustrator",
      "HTML",
      "CSS",
      "JavaScript"
    ],
    "score": 83
  },
  {
    "role": "UX Designer",
    "industry": "Real Estate",
    "exp": 5,
    "required": [
      "FigJam",
      "Framer",
      "Sketch",
      "Adobe XD",
      "Photoshop",
      "Illustrator"
    ],
    "candidate": [
      "Adobe XD",
      "Photoshop",
      "Illustrator",
      "HTML",
      "CSS",
      "JavaScript",
      "React"
    ],
    "score": 91
  },
  {
    "role": "UX Designer",
    "industry": "Real Estate",
    "exp": 7,
    "required": [
      "Framer",
      "Sketch",
      "Adobe XD",
      "Photoshop",
      "Illustrator",
      "HTML"
    ],
    "candidate": [
      "Photoshop",
      "Illustrator",
      "HTML",
      "CSS",
      "JavaScript",
      "React",
      "Product Strategy"
    ],
    "score": 99
  },
  {
    "role": "Product Designer",
    "industry": "SaaS",
    "exp": 1,
    "required": [
      "Sketch",
      "Adobe XD",
      "Photoshop",
      "Illustrator",
      "HTML",
      "CSS"
    ],
    "candidate": [
      "Illustrator",
      "HTML",
      "CSS",
      "JavaScript",
      "React",
      "Product Strategy",
      "Stakeholder Management"
    ],
    "score": 75
  },
  {
    "role": "Product Designer",
    "industry": "SaaS",
    "exp": 2,
    "required": [
      "Adobe XD",
      "Photoshop",
      "Illustrator",
      "HTML",
      "CSS",
      "JavaScript"
    ],
    "candidate": [
      "HTML",
      "CSS",
      "JavaScript",
      "React",
      "Product Strategy",
      "Stakeholder Management",
      "Agile"
    ],
    "score": 79
  },
  {
    "role": "Product Designer",
    "industry": "SaaS",
    "exp": 3,
    "required": [
      "Photoshop",
      "Illustrator",
      "HTML",
      "CSS",
      "JavaScript",
      "React"
    ],
    "candidate": [
      "CSS",
      "JavaScript",
      "React",
      "Product Strategy",
      "Stakeholder Management",
      "Agile",
      "Scrum"
    ],
    "score": 83
  },
  {
    "role": "Product Designer",
    "industry": "SaaS",
    "exp": 5,
    "required": [
      "Illustrator",
      "HTML",
      "CSS",
      "JavaScript",
      "React",
      "Product Strategy"
    ],
    "candidate": [
      "JavaScript",
      "React",
      "Product Strategy",
      "Stakeholder Management",
      "Agile",
      "Scrum",
      "GA4"
    ],
    "score": 91
  },
  {
    "role": "Product Designer",
    "industry": "SaaS",
    "exp": 7,
    "required": [
      "HTML",
      "CSS",
      "JavaScript",
      "React",
      "Product Strategy",
      "Stakeholder Management"
    ],
    "candidate": [
      "React",
      "Product Strategy",
      "Stakeholder Management",
      "Agile",
      "Scrum",
      "GA4",
      "Microsoft Clarity"
    ],
    "score": 99
  },
  {
    "role": "Product Designer",
    "industry": "Enterprise",
    "exp": 1,
    "required": [
      "CSS",
      "JavaScript",
      "React",
      "Product Strategy",
      "Stakeholder Management",
      "Agile"
    ],
    "candidate": [
      "Product Strategy",
      "Stakeholder Management",
      "Agile",
      "Scrum",
      "GA4",
      "Microsoft Clarity",
      "Hotjar"
    ],
    "score": 75
  },
  {
    "role": "Product Designer",
    "industry": "Enterprise",
    "exp": 2,
    "required": [
      "JavaScript",
      "React",
      "Product Strategy",
      "Stakeholder Management",
      "Agile",
      "Scrum"
    ],
    "candidate": [
      "Stakeholder Management",
      "Agile",
      "Scrum",
      "GA4",
      "Microsoft Clarity",
      "Hotjar",
      "Journey Mapping"
    ],
    "score": 79
  },
  {
    "role": "Product Designer",
    "industry": "Enterprise",
    "exp": 3,
    "required": [
      "React",
      "Product Strategy",
      "Stakeholder Management",
      "Agile",
      "Scrum",
      "GA4"
    ],
    "candidate": [
      "Agile",
      "Scrum",
      "GA4",
      "Microsoft Clarity",
      "Hotjar",
      "Journey Mapping",
      "Personas"
    ],
    "score": 83
  },
  {
    "role": "Product Designer",
    "industry": "Enterprise",
    "exp": 5,
    "required": [
      "Product Strategy",
      "Stakeholder Management",
      "Agile",
      "Scrum",
      "GA4",
      "Microsoft Clarity"
    ],
    "candidate": [
      "Scrum",
      "GA4",
      "Microsoft Clarity",
      "Hotjar",
      "Journey Mapping",
      "Personas",
      "Competitive Analysis"
    ],
    "score": 91
  },
  {
    "role": "Product Designer",
    "industry": "Enterprise",
    "exp": 7,
    "required": [
      "Stakeholder Management",
      "Agile",
      "Scrum",
      "GA4",
      "Microsoft Clarity",
      "Hotjar"
    ],
    "candidate": [
      "GA4",
      "Microsoft Clarity",
      "Hotjar",
      "Journey Mapping",
      "Personas",
      "Competitive Analysis",
      "User Flows"
    ],
    "score": 99
  },
  {
    "role": "Product Designer",
    "industry": "FinTech",
    "exp": 1,
    "required": [
      "Agile",
      "Scrum",
      "GA4",
      "Microsoft Clarity",
      "Hotjar",
      "Journey Mapping"
    ],
    "candidate": [
      "Microsoft Clarity",
      "Hotjar",
      "Journey Mapping",
      "Personas",
      "Competitive Analysis",
      "User Flows"
    ],
    "score": 75
  },
  {
    "role": "Product Designer",
    "industry": "FinTech",
    "exp": 2,
    "required": [
      "Scrum",
      "GA4",
      "Microsoft Clarity",
      "Hotjar",
      "Journey Mapping",
      "Personas"
    ],
    "candidate": [
      "Hotjar",
      "Journey Mapping",
      "Personas",
      "Competitive Analysis",
      "User Flows"
    ],
    "score": 79
  },
  {
    "role": "Product Designer",
    "industry": "FinTech",
    "exp": 3,
    "required": [
      "GA4",
      "Microsoft Clarity",
      "Hotjar",
      "Journey Mapping",
      "Personas",
      "Competitive Analysis"
    ],
    "candidate": [
      "Journey Mapping",
      "Personas",
      "Competitive Analysis",
      "User Flows"
    ],
    "score": 83
  },
  {
    "role": "Product Designer",
    "industry": "FinTech",
    "exp": 5,
    "required": [
      "Microsoft Clarity",
      "Hotjar",
      "Journey Mapping",
      "Personas",
      "Competitive Analysis",
      "User Flows"
    ],
    "candidate": [
      "Personas",
      "Competitive Analysis",
      "User Flows"
    ],
    "score": 91
  },
  {
    "role": "Product Designer",
    "industry": "FinTech",
    "exp": 7,
    "required": [
      "Hotjar",
      "Journey Mapping",
      "Personas",
      "Competitive Analysis",
      "User Flows"
    ],
    "candidate": [
      "Competitive Analysis",
      "User Flows"
    ],
    "score": 92
  },
  {
    "role": "Product Designer",
    "industry": "HealthTech",
    "exp": 1,
    "required": [
      "Journey Mapping",
      "Personas",
      "Competitive Analysis",
      "User Flows"
    ],
    "candidate": [
      "User Flows"
    ],
    "score": 61
  },
  {
    "role": "Product Designer",
    "industry": "HealthTech",
    "exp": 2,
    "required": [
      "Personas",
      "Competitive Analysis",
      "User Flows"
    ],
    "candidate": [
      "UX Research",
      "User Interviews",
      "Usability Testing",
      "A/B Testing",
      "Wireframing",
      "Prototyping",
      "Interaction Design"
    ],
    "score": 58
  },
  {
    "role": "Product Designer",
    "industry": "HealthTech",
    "exp": 3,
    "required": [
      "Competitive Analysis",
      "User Flows"
    ],
    "candidate": [
      "User Interviews",
      "Usability Testing",
      "A/B Testing",
      "Wireframing",
      "Prototyping",
      "Interaction Design",
      "Information Architecture"
    ],
    "score": 62
  },
  {
    "role": "Product Designer",
    "industry": "HealthTech",
    "exp": 5,
    "required": [
      "User Flows"
    ],
    "candidate": [
      "Usability Testing",
      "A/B Testing",
      "Wireframing",
      "Prototyping",
      "Interaction Design",
      "Information Architecture",
      "Visual Design"
    ],
    "score": 70
  },
  {
    "role": "Product Designer",
    "industry": "HealthTech",
    "exp": 7,
    "required": [
      "UX Research",
      "User Interviews",
      "Usability Testing",
      "A/B Testing",
      "Wireframing",
      "Prototyping"
    ],
    "candidate": [
      "A/B Testing",
      "Wireframing",
      "Prototyping",
      "Interaction Design",
      "Information Architecture",
      "Visual Design",
      "Typography"
    ],
    "score": 99
  },
  {
    "role": "Product Designer",
    "industry": "EdTech",
    "exp": 1,
    "required": [
      "User Interviews",
      "Usability Testing",
      "A/B Testing",
      "Wireframing",
      "Prototyping",
      "Interaction Design"
    ],
    "candidate": [
      "Wireframing",
      "Prototyping",
      "Interaction Design",
      "Information Architecture",
      "Visual Design",
      "Typography",
      "Color Theory"
    ],
    "score": 75
  },
  {
    "role": "Product Designer",
    "industry": "EdTech",
    "exp": 2,
    "required": [
      "Usability Testing",
      "A/B Testing",
      "Wireframing",
      "Prototyping",
      "Interaction Design",
      "Information Architecture"
    ],
    "candidate": [
      "Prototyping",
      "Interaction Design",
      "Information Architecture",
      "Visual Design",
      "Typography",
      "Color Theory",
      "Design Systems"
    ],
    "score": 79
  },
  {
    "role": "Product Designer",
    "industry": "EdTech",
    "exp": 3,
    "required": [
      "A/B Testing",
      "Wireframing",
      "Prototyping",
      "Interaction Design",
      "Information Architecture",
      "Visual Design"
    ],
    "candidate": [
      "Interaction Design",
      "Information Architecture",
      "Visual Design",
      "Typography",
      "Color Theory",
      "Design Systems",
      "Design Tokens"
    ],
    "score": 83
  },
  {
    "role": "Product Designer",
    "industry": "EdTech",
    "exp": 5,
    "required": [
      "Wireframing",
      "Prototyping",
      "Interaction Design",
      "Information Architecture",
      "Visual Design",
      "Typography"
    ],
    "candidate": [
      "Information Architecture",
      "Visual Design",
      "Typography",
      "Color Theory",
      "Design Systems",
      "Design Tokens",
      "Auto Layout"
    ],
    "score": 91
  },
  {
    "role": "Product Designer",
    "industry": "EdTech",
    "exp": 7,
    "required": [
      "Prototyping",
      "Interaction Design",
      "Information Architecture",
      "Visual Design",
      "Typography",
      "Color Theory"
    ],
    "candidate": [
      "Visual Design",
      "Typography",
      "Color Theory",
      "Design Systems",
      "Design Tokens",
      "Auto Layout",
      "Components"
    ],
    "score": 99
  },
  {
    "role": "Product Designer",
    "industry": "Ecommerce",
    "exp": 1,
    "required": [
      "Interaction Design",
      "Information Architecture",
      "Visual Design",
      "Typography",
      "Color Theory",
      "Design Systems"
    ],
    "candidate": [
      "Typography",
      "Color Theory",
      "Design Systems",
      "Design Tokens",
      "Auto Layout",
      "Components",
      "Variants"
    ],
    "score": 75
  },
  {
    "role": "Product Designer",
    "industry": "Ecommerce",
    "exp": 2,
    "required": [
      "Information Architecture",
      "Visual Design",
      "Typography",
      "Color Theory",
      "Design Systems",
      "Design Tokens"
    ],
    "candidate": [
      "Color Theory",
      "Design Systems",
      "Design Tokens",
      "Auto Layout",
      "Components",
      "Variants",
      "Accessibility"
    ],
    "score": 79
  },
  {
    "role": "Product Designer",
    "industry": "Ecommerce",
    "exp": 3,
    "required": [
      "Visual Design",
      "Typography",
      "Color Theory",
      "Design Systems",
      "Design Tokens",
      "Auto Layout"
    ],
    "candidate": [
      "Design Systems",
      "Design Tokens",
      "Auto Layout",
      "Components",
      "Variants",
      "Accessibility",
      "WCAG"
    ],
    "score": 83
  },
  {
    "role": "Product Designer",
    "industry": "Ecommerce",
    "exp": 5,
    "required": [
      "Typography",
      "Color Theory",
      "Design Systems",
      "Design Tokens",
      "Auto Layout",
      "Components"
    ],
    "candidate": [
      "Design Tokens",
      "Auto Layout",
      "Components",
      "Variants",
      "Accessibility",
      "WCAG",
      "Figma"
    ],
    "score": 91
  },
  {
    "role": "Product Designer",
    "industry": "Ecommerce",
    "exp": 7,
    "required": [
      "Color Theory",
      "Design Systems",
      "Design Tokens",
      "Auto Layout",
      "Components",
      "Variants"
    ],
    "candidate": [
      "Auto Layout",
      "Components",
      "Variants",
      "Accessibility",
      "WCAG",
      "Figma",
      "FigJam"
    ],
    "score": 99
  },
  {
    "role": "Product Designer",
    "industry": "AI",
    "exp": 1,
    "required": [
      "Design Systems",
      "Design Tokens",
      "Auto Layout",
      "Components",
      "Variants",
      "Accessibility"
    ],
    "candidate": [
      "Components",
      "Variants",
      "Accessibility",
      "WCAG",
      "Figma",
      "FigJam",
      "Framer"
    ],
    "score": 75
  },
  {
    "role": "Product Designer",
    "industry": "AI",
    "exp": 2,
    "required": [
      "Design Tokens",
      "Auto Layout",
      "Components",
      "Variants",
      "Accessibility",
      "WCAG"
    ],
    "candidate": [
      "Variants",
      "Accessibility",
      "WCAG",
      "Figma",
      "FigJam",
      "Framer",
      "Sketch"
    ],
    "score": 79
  },
  {
    "role": "Product Designer",
    "industry": "AI",
    "exp": 3,
    "required": [
      "Auto Layout",
      "Components",
      "Variants",
      "Accessibility",
      "WCAG",
      "Figma"
    ],
    "candidate": [
      "Accessibility",
      "WCAG",
      "Figma",
      "FigJam",
      "Framer",
      "Sketch",
      "Adobe XD"
    ],
    "score": 83
  },
  {
    "role": "Product Designer",
    "industry": "AI",
    "exp": 5,
    "required": [
      "Components",
      "Variants",
      "Accessibility",
      "WCAG",
      "Figma",
      "FigJam"
    ],
    "candidate": [
      "WCAG",
      "Figma",
      "FigJam",
      "Framer",
      "Sketch",
      "Adobe XD",
      "Photoshop"
    ],
    "score": 91
  },
  {
    "role": "Product Designer",
    "industry": "AI",
    "exp": 7,
    "required": [
      "Variants",
      "Accessibility",
      "WCAG",
      "Figma",
      "FigJam",
      "Framer"
    ],
    "candidate": [
      "Figma",
      "FigJam",
      "Framer",
      "Sketch",
      "Adobe XD",
      "Photoshop",
      "Illustrator"
    ],
    "score": 99
  },
  {
    "role": "Product Designer",
    "industry": "Mining",
    "exp": 1,
    "required": [
      "Accessibility",
      "WCAG",
      "Figma",
      "FigJam",
      "Framer",
      "Sketch"
    ],
    "candidate": [
      "FigJam",
      "Framer",
      "Sketch",
      "Adobe XD",
      "Photoshop",
      "Illustrator",
      "HTML"
    ],
    "score": 75
  },
  {
    "role": "Product Designer",
    "industry": "Mining",
    "exp": 2,
    "required": [
      "WCAG",
      "Figma",
      "FigJam",
      "Framer",
      "Sketch",
      "Adobe XD"
    ],
    "candidate": [
      "Framer",
      "Sketch",
      "Adobe XD",
      "Photoshop",
      "Illustrator",
      "HTML",
      "CSS"
    ],
    "score": 79
  },
  {
    "role": "Product Designer",
    "industry": "Mining",
    "exp": 3,
    "required": [
      "Figma",
      "FigJam",
      "Framer",
      "Sketch",
      "Adobe XD",
      "Photoshop"
    ],
    "candidate": [
      "Sketch",
      "Adobe XD",
      "Photoshop",
      "Illustrator",
      "HTML",
      "CSS",
      "JavaScript"
    ],
    "score": 83
  },
  {
    "role": "Product Designer",
    "industry": "Mining",
    "exp": 5,
    "required": [
      "FigJam",
      "Framer",
      "Sketch",
      "Adobe XD",
      "Photoshop",
      "Illustrator"
    ],
    "candidate": [
      "Adobe XD",
      "Photoshop",
      "Illustrator",
      "HTML",
      "CSS",
      "JavaScript",
      "React"
    ],
    "score": 91
  },
  {
    "role": "Product Designer",
    "industry": "Mining",
    "exp": 7,
    "required": [
      "Framer",
      "Sketch",
      "Adobe XD",
      "Photoshop",
      "Illustrator",
      "HTML"
    ],
    "candidate": [
      "Photoshop",
      "Illustrator",
      "HTML",
      "CSS",
      "JavaScript",
      "React",
      "Product Strategy"
    ],
    "score": 99
  },
  {
    "role": "Product Designer",
    "industry": "Travel",
    "exp": 1,
    "required": [
      "Sketch",
      "Adobe XD",
      "Photoshop",
      "Illustrator",
      "HTML",
      "CSS"
    ],
    "candidate": [
      "Illustrator",
      "HTML",
      "CSS",
      "JavaScript",
      "React",
      "Product Strategy",
      "Stakeholder Management"
    ],
    "score": 75
  },
  {
    "role": "Product Designer",
    "industry": "Travel",
    "exp": 2,
    "required": [
      "Adobe XD",
      "Photoshop",
      "Illustrator",
      "HTML",
      "CSS",
      "JavaScript"
    ],
    "candidate": [
      "HTML",
      "CSS",
      "JavaScript",
      "React",
      "Product Strategy",
      "Stakeholder Management",
      "Agile"
    ],
    "score": 79
  },
  {
    "role": "Product Designer",
    "industry": "Travel",
    "exp": 3,
    "required": [
      "Photoshop",
      "Illustrator",
      "HTML",
      "CSS",
      "JavaScript",
      "React"
    ],
    "candidate": [
      "CSS",
      "JavaScript",
      "React",
      "Product Strategy",
      "Stakeholder Management",
      "Agile",
      "Scrum"
    ],
    "score": 83
  },
  {
    "role": "Product Designer",
    "industry": "Travel",
    "exp": 5,
    "required": [
      "Illustrator",
      "HTML",
      "CSS",
      "JavaScript",
      "React",
      "Product Strategy"
    ],
    "candidate": [
      "JavaScript",
      "React",
      "Product Strategy",
      "Stakeholder Management",
      "Agile",
      "Scrum",
      "GA4"
    ],
    "score": 91
  },
  {
    "role": "Product Designer",
    "industry": "Travel",
    "exp": 7,
    "required": [
      "HTML",
      "CSS",
      "JavaScript",
      "React",
      "Product Strategy",
      "Stakeholder Management"
    ],
    "candidate": [
      "React",
      "Product Strategy",
      "Stakeholder Management",
      "Agile",
      "Scrum",
      "GA4",
      "Microsoft Clarity"
    ],
    "score": 99
  },
  {
    "role": "Product Designer",
    "industry": "Real Estate",
    "exp": 1,
    "required": [
      "CSS",
      "JavaScript",
      "React",
      "Product Strategy",
      "Stakeholder Management",
      "Agile"
    ],
    "candidate": [
      "Product Strategy",
      "Stakeholder Management",
      "Agile",
      "Scrum",
      "GA4",
      "Microsoft Clarity",
      "Hotjar"
    ],
    "score": 75
  },
  {
    "role": "Product Designer",
    "industry": "Real Estate",
    "exp": 2,
    "required": [
      "JavaScript",
      "React",
      "Product Strategy",
      "Stakeholder Management",
      "Agile",
      "Scrum"
    ],
    "candidate": [
      "Stakeholder Management",
      "Agile",
      "Scrum",
      "GA4",
      "Microsoft Clarity",
      "Hotjar",
      "Journey Mapping"
    ],
    "score": 79
  },
  {
    "role": "Product Designer",
    "industry": "Real Estate",
    "exp": 3,
    "required": [
      "React",
      "Product Strategy",
      "Stakeholder Management",
      "Agile",
      "Scrum",
      "GA4"
    ],
    "candidate": [
      "Agile",
      "Scrum",
      "GA4",
      "Microsoft Clarity",
      "Hotjar",
      "Journey Mapping",
      "Personas"
    ],
    "score": 83
  },
  {
    "role": "Product Designer",
    "industry": "Real Estate",
    "exp": 5,
    "required": [
      "Product Strategy",
      "Stakeholder Management",
      "Agile",
      "Scrum",
      "GA4",
      "Microsoft Clarity"
    ],
    "candidate": [
      "Scrum",
      "GA4",
      "Microsoft Clarity",
      "Hotjar",
      "Journey Mapping",
      "Personas",
      "Competitive Analysis"
    ],
    "score": 91
  },
  {
    "role": "Product Designer",
    "industry": "Real Estate",
    "exp": 7,
    "required": [
      "Stakeholder Management",
      "Agile",
      "Scrum",
      "GA4",
      "Microsoft Clarity",
      "Hotjar"
    ],
    "candidate": [
      "GA4",
      "Microsoft Clarity",
      "Hotjar",
      "Journey Mapping",
      "Personas",
      "Competitive Analysis",
      "User Flows"
    ],
    "score": 99
  },
  {
    "role": "Senior Product Designer",
    "industry": "SaaS",
    "exp": 1,
    "required": [
      "Agile",
      "Scrum",
      "GA4",
      "Microsoft Clarity",
      "Hotjar",
      "Journey Mapping"
    ],
    "candidate": [
      "Microsoft Clarity",
      "Hotjar",
      "Journey Mapping",
      "Personas",
      "Competitive Analysis",
      "User Flows"
    ],
    "score": 75
  },
  {
    "role": "Senior Product Designer",
    "industry": "SaaS",
    "exp": 2,
    "required": [
      "Scrum",
      "GA4",
      "Microsoft Clarity",
      "Hotjar",
      "Journey Mapping",
      "Personas"
    ],
    "candidate": [
      "Hotjar",
      "Journey Mapping",
      "Personas",
      "Competitive Analysis",
      "User Flows"
    ],
    "score": 79
  },
  {
    "role": "Senior Product Designer",
    "industry": "SaaS",
    "exp": 3,
    "required": [
      "GA4",
      "Microsoft Clarity",
      "Hotjar",
      "Journey Mapping",
      "Personas",
      "Competitive Analysis"
    ],
    "candidate": [
      "Journey Mapping",
      "Personas",
      "Competitive Analysis",
      "User Flows"
    ],
    "score": 83
  },
  {
    "role": "Senior Product Designer",
    "industry": "SaaS",
    "exp": 5,
    "required": [
      "Microsoft Clarity",
      "Hotjar",
      "Journey Mapping",
      "Personas",
      "Competitive Analysis",
      "User Flows"
    ],
    "candidate": [
      "Personas",
      "Competitive Analysis",
      "User Flows"
    ],
    "score": 91
  },
  {
    "role": "Senior Product Designer",
    "industry": "SaaS",
    "exp": 7,
    "required": [
      "Hotjar",
      "Journey Mapping",
      "Personas",
      "Competitive Analysis",
      "User Flows"
    ],
    "candidate": [
      "Competitive Analysis",
      "User Flows"
    ],
    "score": 92
  },
  {
    "role": "Senior Product Designer",
    "industry": "Enterprise",
    "exp": 1,
    "required": [
      "Journey Mapping",
      "Personas",
      "Competitive Analysis",
      "User Flows"
    ],
    "candidate": [
      "User Flows"
    ],
    "score": 61
  },
  {
    "role": "Senior Product Designer",
    "industry": "Enterprise",
    "exp": 2,
    "required": [
      "Personas",
      "Competitive Analysis",
      "User Flows"
    ],
    "candidate": [
      "UX Research",
      "User Interviews",
      "Usability Testing",
      "A/B Testing",
      "Wireframing",
      "Prototyping",
      "Interaction Design"
    ],
    "score": 58
  },
  {
    "role": "Senior Product Designer",
    "industry": "Enterprise",
    "exp": 3,
    "required": [
      "Competitive Analysis",
      "User Flows"
    ],
    "candidate": [
      "User Interviews",
      "Usability Testing",
      "A/B Testing",
      "Wireframing",
      "Prototyping",
      "Interaction Design",
      "Information Architecture"
    ],
    "score": 62
  },
  {
    "role": "Senior Product Designer",
    "industry": "Enterprise",
    "exp": 5,
    "required": [
      "User Flows"
    ],
    "candidate": [
      "Usability Testing",
      "A/B Testing",
      "Wireframing",
      "Prototyping",
      "Interaction Design",
      "Information Architecture",
      "Visual Design"
    ],
    "score": 70
  },
  {
    "role": "Senior Product Designer",
    "industry": "Enterprise",
    "exp": 7,
    "required": [
      "UX Research",
      "User Interviews",
      "Usability Testing",
      "A/B Testing",
      "Wireframing",
      "Prototyping"
    ],
    "candidate": [
      "A/B Testing",
      "Wireframing",
      "Prototyping",
      "Interaction Design",
      "Information Architecture",
      "Visual Design",
      "Typography"
    ],
    "score": 99
  },
  {
    "role": "Senior Product Designer",
    "industry": "FinTech",
    "exp": 1,
    "required": [
      "User Interviews",
      "Usability Testing",
      "A/B Testing",
      "Wireframing",
      "Prototyping",
      "Interaction Design"
    ],
    "candidate": [
      "Wireframing",
      "Prototyping",
      "Interaction Design",
      "Information Architecture",
      "Visual Design",
      "Typography",
      "Color Theory"
    ],
    "score": 75
  },
  {
    "role": "Senior Product Designer",
    "industry": "FinTech",
    "exp": 2,
    "required": [
      "Usability Testing",
      "A/B Testing",
      "Wireframing",
      "Prototyping",
      "Interaction Design",
      "Information Architecture"
    ],
    "candidate": [
      "Prototyping",
      "Interaction Design",
      "Information Architecture",
      "Visual Design",
      "Typography",
      "Color Theory",
      "Design Systems"
    ],
    "score": 79
  },
  {
    "role": "Senior Product Designer",
    "industry": "FinTech",
    "exp": 3,
    "required": [
      "A/B Testing",
      "Wireframing",
      "Prototyping",
      "Interaction Design",
      "Information Architecture",
      "Visual Design"
    ],
    "candidate": [
      "Interaction Design",
      "Information Architecture",
      "Visual Design",
      "Typography",
      "Color Theory",
      "Design Systems",
      "Design Tokens"
    ],
    "score": 83
  },
  {
    "role": "Senior Product Designer",
    "industry": "FinTech",
    "exp": 5,
    "required": [
      "Wireframing",
      "Prototyping",
      "Interaction Design",
      "Information Architecture",
      "Visual Design",
      "Typography"
    ],
    "candidate": [
      "Information Architecture",
      "Visual Design",
      "Typography",
      "Color Theory",
      "Design Systems",
      "Design Tokens",
      "Auto Layout"
    ],
    "score": 91
  },
  {
    "role": "Senior Product Designer",
    "industry": "FinTech",
    "exp": 7,
    "required": [
      "Prototyping",
      "Interaction Design",
      "Information Architecture",
      "Visual Design",
      "Typography",
      "Color Theory"
    ],
    "candidate": [
      "Visual Design",
      "Typography",
      "Color Theory",
      "Design Systems",
      "Design Tokens",
      "Auto Layout",
      "Components"
    ],
    "score": 99
  },
  {
    "role": "Senior Product Designer",
    "industry": "HealthTech",
    "exp": 1,
    "required": [
      "Interaction Design",
      "Information Architecture",
      "Visual Design",
      "Typography",
      "Color Theory",
      "Design Systems"
    ],
    "candidate": [
      "Typography",
      "Color Theory",
      "Design Systems",
      "Design Tokens",
      "Auto Layout",
      "Components",
      "Variants"
    ],
    "score": 75
  },
  {
    "role": "Senior Product Designer",
    "industry": "HealthTech",
    "exp": 2,
    "required": [
      "Information Architecture",
      "Visual Design",
      "Typography",
      "Color Theory",
      "Design Systems",
      "Design Tokens"
    ],
    "candidate": [
      "Color Theory",
      "Design Systems",
      "Design Tokens",
      "Auto Layout",
      "Components",
      "Variants",
      "Accessibility"
    ],
    "score": 79
  },
  {
    "role": "Senior Product Designer",
    "industry": "HealthTech",
    "exp": 3,
    "required": [
      "Visual Design",
      "Typography",
      "Color Theory",
      "Design Systems",
      "Design Tokens",
      "Auto Layout"
    ],
    "candidate": [
      "Design Systems",
      "Design Tokens",
      "Auto Layout",
      "Components",
      "Variants",
      "Accessibility",
      "WCAG"
    ],
    "score": 83
  },
  {
    "role": "Senior Product Designer",
    "industry": "HealthTech",
    "exp": 5,
    "required": [
      "Typography",
      "Color Theory",
      "Design Systems",
      "Design Tokens",
      "Auto Layout",
      "Components"
    ],
    "candidate": [
      "Design Tokens",
      "Auto Layout",
      "Components",
      "Variants",
      "Accessibility",
      "WCAG",
      "Figma"
    ],
    "score": 91
  },
  {
    "role": "Senior Product Designer",
    "industry": "HealthTech",
    "exp": 7,
    "required": [
      "Color Theory",
      "Design Systems",
      "Design Tokens",
      "Auto Layout",
      "Components",
      "Variants"
    ],
    "candidate": [
      "Auto Layout",
      "Components",
      "Variants",
      "Accessibility",
      "WCAG",
      "Figma",
      "FigJam"
    ],
    "score": 99
  },
  {
    "role": "Senior Product Designer",
    "industry": "EdTech",
    "exp": 1,
    "required": [
      "Design Systems",
      "Design Tokens",
      "Auto Layout",
      "Components",
      "Variants",
      "Accessibility"
    ],
    "candidate": [
      "Components",
      "Variants",
      "Accessibility",
      "WCAG",
      "Figma",
      "FigJam",
      "Framer"
    ],
    "score": 75
  },
  {
    "role": "Senior Product Designer",
    "industry": "EdTech",
    "exp": 2,
    "required": [
      "Design Tokens",
      "Auto Layout",
      "Components",
      "Variants",
      "Accessibility",
      "WCAG"
    ],
    "candidate": [
      "Variants",
      "Accessibility",
      "WCAG",
      "Figma",
      "FigJam",
      "Framer",
      "Sketch"
    ],
    "score": 79
  },
  {
    "role": "Senior Product Designer",
    "industry": "EdTech",
    "exp": 3,
    "required": [
      "Auto Layout",
      "Components",
      "Variants",
      "Accessibility",
      "WCAG",
      "Figma"
    ],
    "candidate": [
      "Accessibility",
      "WCAG",
      "Figma",
      "FigJam",
      "Framer",
      "Sketch",
      "Adobe XD"
    ],
    "score": 83
  },
  {
    "role": "Senior Product Designer",
    "industry": "EdTech",
    "exp": 5,
    "required": [
      "Components",
      "Variants",
      "Accessibility",
      "WCAG",
      "Figma",
      "FigJam"
    ],
    "candidate": [
      "WCAG",
      "Figma",
      "FigJam",
      "Framer",
      "Sketch",
      "Adobe XD",
      "Photoshop"
    ],
    "score": 91
  },
  {
    "role": "Senior Product Designer",
    "industry": "EdTech",
    "exp": 7,
    "required": [
      "Variants",
      "Accessibility",
      "WCAG",
      "Figma",
      "FigJam",
      "Framer"
    ],
    "candidate": [
      "Figma",
      "FigJam",
      "Framer",
      "Sketch",
      "Adobe XD",
      "Photoshop",
      "Illustrator"
    ],
    "score": 99
  },
  {
    "role": "Senior Product Designer",
    "industry": "Ecommerce",
    "exp": 1,
    "required": [
      "Accessibility",
      "WCAG",
      "Figma",
      "FigJam",
      "Framer",
      "Sketch"
    ],
    "candidate": [
      "FigJam",
      "Framer",
      "Sketch",
      "Adobe XD",
      "Photoshop",
      "Illustrator",
      "HTML"
    ],
    "score": 75
  },
  {
    "role": "Senior Product Designer",
    "industry": "Ecommerce",
    "exp": 2,
    "required": [
      "WCAG",
      "Figma",
      "FigJam",
      "Framer",
      "Sketch",
      "Adobe XD"
    ],
    "candidate": [
      "Framer",
      "Sketch",
      "Adobe XD",
      "Photoshop",
      "Illustrator",
      "HTML",
      "CSS"
    ],
    "score": 79
  },
  {
    "role": "Senior Product Designer",
    "industry": "Ecommerce",
    "exp": 3,
    "required": [
      "Figma",
      "FigJam",
      "Framer",
      "Sketch",
      "Adobe XD",
      "Photoshop"
    ],
    "candidate": [
      "Sketch",
      "Adobe XD",
      "Photoshop",
      "Illustrator",
      "HTML",
      "CSS",
      "JavaScript"
    ],
    "score": 83
  },
  {
    "role": "Senior Product Designer",
    "industry": "Ecommerce",
    "exp": 5,
    "required": [
      "FigJam",
      "Framer",
      "Sketch",
      "Adobe XD",
      "Photoshop",
      "Illustrator"
    ],
    "candidate": [
      "Adobe XD",
      "Photoshop",
      "Illustrator",
      "HTML",
      "CSS",
      "JavaScript",
      "React"
    ],
    "score": 91
  },
  {
    "role": "Senior Product Designer",
    "industry": "Ecommerce",
    "exp": 7,
    "required": [
      "Framer",
      "Sketch",
      "Adobe XD",
      "Photoshop",
      "Illustrator",
      "HTML"
    ],
    "candidate": [
      "Photoshop",
      "Illustrator",
      "HTML",
      "CSS",
      "JavaScript",
      "React",
      "Product Strategy"
    ],
    "score": 99
  },
  {
    "role": "Senior Product Designer",
    "industry": "AI",
    "exp": 1,
    "required": [
      "Sketch",
      "Adobe XD",
      "Photoshop",
      "Illustrator",
      "HTML",
      "CSS"
    ],
    "candidate": [
      "Illustrator",
      "HTML",
      "CSS",
      "JavaScript",
      "React",
      "Product Strategy",
      "Stakeholder Management"
    ],
    "score": 75
  },
  {
    "role": "Senior Product Designer",
    "industry": "AI",
    "exp": 2,
    "required": [
      "Adobe XD",
      "Photoshop",
      "Illustrator",
      "HTML",
      "CSS",
      "JavaScript"
    ],
    "candidate": [
      "HTML",
      "CSS",
      "JavaScript",
      "React",
      "Product Strategy",
      "Stakeholder Management",
      "Agile"
    ],
    "score": 79
  },
  {
    "role": "Senior Product Designer",
    "industry": "AI",
    "exp": 3,
    "required": [
      "Photoshop",
      "Illustrator",
      "HTML",
      "CSS",
      "JavaScript",
      "React"
    ],
    "candidate": [
      "CSS",
      "JavaScript",
      "React",
      "Product Strategy",
      "Stakeholder Management",
      "Agile",
      "Scrum"
    ],
    "score": 83
  },
  {
    "role": "Senior Product Designer",
    "industry": "AI",
    "exp": 5,
    "required": [
      "Illustrator",
      "HTML",
      "CSS",
      "JavaScript",
      "React",
      "Product Strategy"
    ],
    "candidate": [
      "JavaScript",
      "React",
      "Product Strategy",
      "Stakeholder Management",
      "Agile",
      "Scrum",
      "GA4"
    ],
    "score": 91
  },
  {
    "role": "Senior Product Designer",
    "industry": "AI",
    "exp": 7,
    "required": [
      "HTML",
      "CSS",
      "JavaScript",
      "React",
      "Product Strategy",
      "Stakeholder Management"
    ],
    "candidate": [
      "React",
      "Product Strategy",
      "Stakeholder Management",
      "Agile",
      "Scrum",
      "GA4",
      "Microsoft Clarity"
    ],
    "score": 99
  },
  {
    "role": "Senior Product Designer",
    "industry": "Mining",
    "exp": 1,
    "required": [
      "CSS",
      "JavaScript",
      "React",
      "Product Strategy",
      "Stakeholder Management",
      "Agile"
    ],
    "candidate": [
      "Product Strategy",
      "Stakeholder Management",
      "Agile",
      "Scrum",
      "GA4",
      "Microsoft Clarity",
      "Hotjar"
    ],
    "score": 75
  },
  {
    "role": "Senior Product Designer",
    "industry": "Mining",
    "exp": 2,
    "required": [
      "JavaScript",
      "React",
      "Product Strategy",
      "Stakeholder Management",
      "Agile",
      "Scrum"
    ],
    "candidate": [
      "Stakeholder Management",
      "Agile",
      "Scrum",
      "GA4",
      "Microsoft Clarity",
      "Hotjar",
      "Journey Mapping"
    ],
    "score": 79
  },
  {
    "role": "Senior Product Designer",
    "industry": "Mining",
    "exp": 3,
    "required": [
      "React",
      "Product Strategy",
      "Stakeholder Management",
      "Agile",
      "Scrum",
      "GA4"
    ],
    "candidate": [
      "Agile",
      "Scrum",
      "GA4",
      "Microsoft Clarity",
      "Hotjar",
      "Journey Mapping",
      "Personas"
    ],
    "score": 83
  },
  {
    "role": "Senior Product Designer",
    "industry": "Mining",
    "exp": 5,
    "required": [
      "Product Strategy",
      "Stakeholder Management",
      "Agile",
      "Scrum",
      "GA4",
      "Microsoft Clarity"
    ],
    "candidate": [
      "Scrum",
      "GA4",
      "Microsoft Clarity",
      "Hotjar",
      "Journey Mapping",
      "Personas",
      "Competitive Analysis"
    ],
    "score": 91
  },
  {
    "role": "Senior Product Designer",
    "industry": "Mining",
    "exp": 7,
    "required": [
      "Stakeholder Management",
      "Agile",
      "Scrum",
      "GA4",
      "Microsoft Clarity",
      "Hotjar"
    ],
    "candidate": [
      "GA4",
      "Microsoft Clarity",
      "Hotjar",
      "Journey Mapping",
      "Personas",
      "Competitive Analysis",
      "User Flows"
    ],
    "score": 99
  },
  {
    "role": "Senior Product Designer",
    "industry": "Travel",
    "exp": 1,
    "required": [
      "Agile",
      "Scrum",
      "GA4",
      "Microsoft Clarity",
      "Hotjar",
      "Journey Mapping"
    ],
    "candidate": [
      "Microsoft Clarity",
      "Hotjar",
      "Journey Mapping",
      "Personas",
      "Competitive Analysis",
      "User Flows"
    ],
    "score": 75
  },
  {
    "role": "Senior Product Designer",
    "industry": "Travel",
    "exp": 2,
    "required": [
      "Scrum",
      "GA4",
      "Microsoft Clarity",
      "Hotjar",
      "Journey Mapping",
      "Personas"
    ],
    "candidate": [
      "Hotjar",
      "Journey Mapping",
      "Personas",
      "Competitive Analysis",
      "User Flows"
    ],
    "score": 79
  },
  {
    "role": "Senior Product Designer",
    "industry": "Travel",
    "exp": 3,
    "required": [
      "GA4",
      "Microsoft Clarity",
      "Hotjar",
      "Journey Mapping",
      "Personas",
      "Competitive Analysis"
    ],
    "candidate": [
      "Journey Mapping",
      "Personas",
      "Competitive Analysis",
      "User Flows"
    ],
    "score": 83
  },
  {
    "role": "Senior Product Designer",
    "industry": "Travel",
    "exp": 5,
    "required": [
      "Microsoft Clarity",
      "Hotjar",
      "Journey Mapping",
      "Personas",
      "Competitive Analysis",
      "User Flows"
    ],
    "candidate": [
      "Personas",
      "Competitive Analysis",
      "User Flows"
    ],
    "score": 91
  },
  {
    "role": "Senior Product Designer",
    "industry": "Travel",
    "exp": 7,
    "required": [
      "Hotjar",
      "Journey Mapping",
      "Personas",
      "Competitive Analysis",
      "User Flows"
    ],
    "candidate": [
      "Competitive Analysis",
      "User Flows"
    ],
    "score": 92
  },
  {
    "role": "Senior Product Designer",
    "industry": "Real Estate",
    "exp": 1,
    "required": [
      "Journey Mapping",
      "Personas",
      "Competitive Analysis",
      "User Flows"
    ],
    "candidate": [
      "User Flows"
    ],
    "score": 61
  },
  {
    "role": "Senior Product Designer",
    "industry": "Real Estate",
    "exp": 2,
    "required": [
      "Personas",
      "Competitive Analysis",
      "User Flows"
    ],
    "candidate": [
      "UX Research",
      "User Interviews",
      "Usability Testing",
      "A/B Testing",
      "Wireframing",
      "Prototyping",
      "Interaction Design"
    ],
    "score": 58
  },
  {
    "role": "Senior Product Designer",
    "industry": "Real Estate",
    "exp": 3,
    "required": [
      "Competitive Analysis",
      "User Flows"
    ],
    "candidate": [
      "User Interviews",
      "Usability Testing",
      "A/B Testing",
      "Wireframing",
      "Prototyping",
      "Interaction Design",
      "Information Architecture"
    ],
    "score": 62
  },
  {
    "role": "Senior Product Designer",
    "industry": "Real Estate",
    "exp": 5,
    "required": [
      "User Flows"
    ],
    "candidate": [
      "Usability Testing",
      "A/B Testing",
      "Wireframing",
      "Prototyping",
      "Interaction Design",
      "Information Architecture",
      "Visual Design"
    ],
    "score": 70
  },
  {
    "role": "Senior Product Designer",
    "industry": "Real Estate",
    "exp": 7,
    "required": [
      "UX Research",
      "User Interviews",
      "Usability Testing",
      "A/B Testing",
      "Wireframing",
      "Prototyping"
    ],
    "candidate": [
      "A/B Testing",
      "Wireframing",
      "Prototyping",
      "Interaction Design",
      "Information Architecture",
      "Visual Design",
      "Typography"
    ],
    "score": 99
  },
  {
    "role": "Lead Product Designer",
    "industry": "SaaS",
    "exp": 1,
    "required": [
      "User Interviews",
      "Usability Testing",
      "A/B Testing",
      "Wireframing",
      "Prototyping",
      "Interaction Design"
    ],
    "candidate": [
      "Wireframing",
      "Prototyping",
      "Interaction Design",
      "Information Architecture",
      "Visual Design",
      "Typography",
      "Color Theory"
    ],
    "score": 75
  },
  {
    "role": "Lead Product Designer",
    "industry": "SaaS",
    "exp": 2,
    "required": [
      "Usability Testing",
      "A/B Testing",
      "Wireframing",
      "Prototyping",
      "Interaction Design",
      "Information Architecture"
    ],
    "candidate": [
      "Prototyping",
      "Interaction Design",
      "Information Architecture",
      "Visual Design",
      "Typography",
      "Color Theory",
      "Design Systems"
    ],
    "score": 79
  },
  {
    "role": "Lead Product Designer",
    "industry": "SaaS",
    "exp": 3,
    "required": [
      "A/B Testing",
      "Wireframing",
      "Prototyping",
      "Interaction Design",
      "Information Architecture",
      "Visual Design"
    ],
    "candidate": [
      "Interaction Design",
      "Information Architecture",
      "Visual Design",
      "Typography",
      "Color Theory",
      "Design Systems",
      "Design Tokens"
    ],
    "score": 83
  }
];
